import { FunctionComponent, useEffect, useState } from "react";
import ApiTopBar from "../../Components/TopBar/ApiTopBar";
import commonStyle from "../common.module.css";
import { connect, useDispatch } from "react-redux";
import OwnerModal from "../../Components/Modals/ChangeOwnerModal/ChangeOwnerModal";
import {maskedBossterMonthWise} from "../../Services/contacts"
import {
  CONTACT_COLUMNS,
  datesField,
  booleanObject,
  CONTACT_COLUMNS_REAL,
} from "../../Values/tables";
import Firebase from "firebase/app";
import styles from '../Analytics/Analytics.module.css'
import Loading from "../../Components/Loading/Loading";
import { getDateStringUpdated, openCustomMMBURL ,fetchBanner} from "../../Values/utils";
import ApiCustomTable from "../../Components/CustomTable/ApiCustomTable";
import BulkEditModal from "../../Components/Modals/BulkEditModal/BulkEditModal";
import ImportCallLogsModal from "../../Components/Modals/ImportModal/ImportCallLogsModal";
import ImportNotesModal from "../../Components/Modals/ImportModal/ImportNotesModal";
import ImportTasksModal from "../../Components/Modals/ImportModal/ImportTasksModal";
import moment from "moment";
import { contactFilterValues, url } from "../../Values/constants";
import {
  setFilterObject,
  setRefreshContacts,
  showSnackbarAction,
  clearAllFilters,
  setCurrentRoute
} from "../../Redux/actions";
import NewImportContactModal from "../../Components/Modals/ImportModal/NewImportContactModal";
import DeleteSelectedModalSoftDelete from "../../Components/Modals/DeleteSelectedModal/DeleteSelectedModalSoftDelete";
import {themeColors} from "../../Components/theme";
import PopUpBox from "../AuditLogs/PopUpBox";
import axiosHandler from "../../Services/axiosHandler";
import { googleAnalytics ,pushToGA} from "../../Services/users";
import CenteredPopUp from "../../Components/CenteredPopUp/CenteredPopUp";
import FreeTrialWhatsappModal from "../FreeTrials/FreeTrialWhatsappModal";
import FreeTrialActivatedModal from "../FreeTrials/FreeTrialActivatedModal";
import MaskedLeadBanner from "../../Components/Banners/MaskedLeadBanner";
import HtmlBanner from "../../bannerManagement/baneerComp";
import { useLocation } from 'react-router-dom';

type props = {
  history: any;
  user: any;
  contacts: {
    data: any;
  };
  organizationUsers: any;
  role: any;
  teamLeadUsers: any;
  filterObject: any;
  filterSort: any;
  refreshContacts: boolean;
  searchString: string;
  theme:any;
  authToken:any;
  organizationData:any;
  Window: any;
  isUsingApp: boolean;
};
let usersList: any[] = [];
let isFinished = false;
const UserPanel: FunctionComponent<props> = ({
  history,
  user,
  contacts,
  organizationUsers,
  role,
  teamLeadUsers,
  filterObject,
  filterSort,
  refreshContacts,
  searchString,
  theme,
  authToken,
  organizationData,
  Window,
  isUsingApp
}) => {
  const [showImportModal, setShowImportModal] = useState(false);
  const [callLogsImportModal, setCallLogsImportModal] = useState(false);
  const [notesImportModal, setNotesImportModal] = useState(false);
  const [tasksImportModal, setTasksImportModal] = useState(false);
  const [show, setShow] = useState(false);
  const [filterCount, setFilterCount] = useState<any>({});
  const [deletePopup, setDeletePopop] = useState(false);
  const [showBulkEdit, setShowBulkEdit] = useState(false);
  const [owner, setOwner] = useState(false);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [selectedRowsData, setSelectedRowsData] = useState<any[]>([]);
  const [transferStatusTrueRows, setTransferStatusTrueRows] = useState<any[]>([]);
  const [filterData, setFilterData] = useState<any[] | undefined>(undefined);
  const [searchedItem, setsearchedItem] = useState("");
  const [columnModal, setColumnModal] = useState(false);
  const [lastPage, setLastPage] = useState(-1);
  const [allContacts, setAllContacts] = useState<any[] | undefined>(undefined);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(100);
  const [load, setLoad] = useState(false);
  const [allLeads, setAllLeads] = useState(false);
  const [totalCounts, setTotalCounts] = useState<any>();
  const [userMap, setUserMap] = useState<any>(undefined);
  const [userBranchMap, setBranchMap] = useState<any>(undefined);
  const [userTeamMap, setTeamMap] = useState<any>(undefined);
  const [freshFilterValue, setFreshFilterValue] = useState<any>();
  let dispatcher = useDispatch();
  const [auditLog, setAuditLog] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState(false);                  
  const [userEmail, setUserEmail] = useState<any>(undefined);
  const [showColumns, setShowColumns] = useState<any>(null);
  const [isGACalled, setIsGACalled] = useState<any>(false);
  const [contactColumns, setContactColumns] = useState<any>(CONTACT_COLUMNS_REAL);
  const [showFreeTrialModal, setShowFreeTrialModal] = useState(false);
  const [showTrialActivatedModal, setShowTrialActivatedModal] = useState(false);
  const [autoToken, setAutoToken] = useState("");
  const [cRoute,setCRoute]=useState("")

  
  // useEffect(()=>{
    //   dispatcher(clearAllFilters({}));
    // },[])

    const location = useLocation();

  useEffect(() => {
    dispatcher(setCurrentRoute(location.pathname))
    setCRoute(location.pathname)
  }, [location]);

  const createUsersList = (email: string, users: any[], uid: boolean) => {
    users.map((item: any) => {
      if (usersList.includes(item)) {
        return;
      } else {
        if (item.reporting_to === email && item.status === "ACTIVE" && item.profile != "Admin" && item.profile != "Operation Manager") {
          if (!usersList.includes(item)) {
            usersList.push(item);
          }
          createUsersList(item.user_email, users, uid);
        }
      }
    });
  };

  useEffect(() => {
    let trueStatusList: any = [];
    selectedRowsData.forEach((row) => {
      Object.keys(row).forEach((item) => {
        if (item === "transfer_status") {
          trueStatusList.push(row[item]);
        }
      });
    });
    setTransferStatusTrueRows(trueStatusList);
  }, [selectedRowsData]);

  useEffect(() => {
    if (organizationUsers) {
      let uids: { [key: string]: string } = {};
      let uidsBranch: { [key: string]: string } = {};
      let uidsTeam: { [key: string]: string } = {};
      // To store info of user
      let emailInfo: { [key: string]: string } = {};

      organizationUsers.forEach((user: any) => {
        uids[user.user_email] = user.reporting_to;
        uidsBranch[user.user_email] = user.branch;
        uidsTeam[user.user_email] = user.team;
        emailInfo[user.user_email]=user;
      });
      setBranchMap(uidsBranch)
      setUserMap(uids);
      setTeamMap(uidsTeam)
      setUserEmail(emailInfo)
    }
  }, [organizationUsers]);

  const callApi = async (
    paginate?: boolean,
    localPageSize?: Number,
    localPage?: Number
  ) => {
    if (isFinished === true) {
      return;
    } else {
      setLoad(true);
      const filters: { [key: string]: any[] } = {};
      let feild;
      filters["transfer_status"] = [false];
      Object.keys(filterObject).forEach((item) => {
        if (filterObject && filterObject[item].length > 0) {
          if (item === "is_button_called" || item === "transfer_status" || item === "associate_status" || item === "source_status") {
            if (filterObject[item].length === 2) {
              filters[item] = [true, false];
            } else {
              filters[item] =
                filterObject[item][0] === "True" ? [true] : [false];
            }
          } else {
            //FIXME: Here contact_no is getting set which is coming from behind
            //below code checks if item con_no but val not number, then use con_email instead
            if (item === "contact_no") {
            } else filters[item] = filterObject[item];
          }
        }
      });
      if (searchString === "") {
        feild = "customer_name";
      } else {
        if (searchString.match(/^[0-9]+$/) != null) {
          feild = "contact_no";
        } else {
          feild = "customer_name";
        }
      }
      setFilterCount(filters)
      let records = localPageSize ? localPageSize : pageSize;
      const apiData = {
        uid: user.uid,
        page: localPage ? localPage : page + 1,
        searchString: searchString,
        sort:
          Object.keys(filterSort).length === 0
            ? { created_at: "-1" }
            : filterSort,
        pageSize: localPageSize ? localPageSize : pageSize,
        filter: filters,
      };
      try {
        // axios.defaults.headers.common["x-access-token"] =
        //   authToken
        const res = await axiosHandler.post(url + "/leads/search", apiData);
        let data: any[] = res.data;
        if (data.length < records) {
          isFinished = true;
          setLastPage(page);
        }
        data.forEach((lead) => {
          lead.contactId = lead.Id;
          lead["reporting_to"] = userMap[lead.contact_owner_email];
          lead["branch"] = userBranchMap[lead.contact_owner_email];
          lead["team"] = userTeamMap[lead.contact_owner_email];
          let info=userEmail[lead.contact_owner_email];
          if(info){
            lead.employee_id=info.employee_id?info.employee_id:"";
              if(info.user_first_name || info.user_last_name){
                lead.employee_name=info.user_first_name+" "+info.user_last_name;
              }
          }
          delete lead["Id"];
          Object.keys(lead).forEach((key) => {
            if (datesField.includes(key) && lead[key] !== "") {
              if (lead[key] !== null) {
                lead[key] = Firebase.firestore.Timestamp.fromDate(
                  moment(lead[key]).toDate()
                );
              } else {
                lead[key] = "";
              }
            }
          });
        });
        if (paginate && filterData) {
          let newData = [...filterData, ...data];
          setFilterData(newData);
        } else {
          setFilterData(data);
        }
        setLoad(false);
      } catch (e) {
        setLoad(false);
      }
    }
  };

  useEffect(() => {
    if (user === undefined || user.uid === undefined) {
      setFilterData([]);
      return;
    }
    if (userMap === undefined || userTeamMap === undefined || userBranchMap === undefined) {
      setFilterData([]);
      return;
    }
    isFinished = false;
    setLastPage(-1);
    if (page !== 0) {
      setPage(0);
    }
    const filterStageValue = filterObject.stage?.length === 1 && filterObject?.stage?.filter((item: any) => item === "FRESH");
    filterStageValue ? setFreshFilterValue(filterStageValue[0]) : setFreshFilterValue('');
    if(authToken){
      callApi(false, pageSize, 1);
    }
  }, [user, filterObject, filterSort, searchString, allLeads, userMap, userTeamMap, userBranchMap,authToken]);
    
  useEffect(() => {
    if (
      filterData &&
      filterData.length <= (page + 1) * pageSize &&
      isFinished === false
    ) {
      if (page === 0) {
        if(authToken){
          callApi(false, pageSize);
        }
      } else {
        if(authToken){
          callApi(true, pageSize);
        }
      }
    }
  }, [page, pageSize,authToken]);

  useEffect(() => {
    if (user === undefined || user.uid === undefined) {
      setFilterData([]);
      return;
    }
    if(authToken){
      contactCountApi()
    }
  }, [refreshContacts, user.uid, filterCount,authToken]);
  const contactCountApi = async () => {
    const { reporting_to, team, branch, ...otherFilterCount } = filterCount;
    // axios.defaults.headers.common["x-access-token"] =
    //   authToken
    const res = await axiosHandler.post(url + "/leads/contacttotalcount", {
      uid: user.uid,
      leadFilter: otherFilterCount,
      leadUserFilter: {
        reporting_to,
        team,
        branch
      },
      role:true
    });
    setTotalCounts(res.data.total);
  };

  useEffect(() => {
    if (refreshContacts === true) {
      if(authToken){
        callApi();
      getContactsFilter();
      dispatcher(setRefreshContacts(false));
      const filterStageValue = filterObject.stage?.length === 1 && filterObject?.stage?.filter((item: any) => item === "FRESH");
      filterStageValue ? setFreshFilterValue(filterStageValue[0]) : setFreshFilterValue('');
      }
    }
  }, [refreshContacts,authToken]);

  useEffect(() => {
    if(authToken){
      callApi();
    const filterStageValue = filterObject.stage?.length === 1 && filterObject?.stage?.filter((item: any) => item === "FRESH");
    filterStageValue ? setFreshFilterValue(filterStageValue[0]) : setFreshFilterValue('');
    }
  }, [filterObject,authToken]);

  // useEffect(()=>{
  //   const storedValue = localStorage.getItem('contactShowFilterValues');
  //   setShowColumns(storedValue);
  //   getContactsFilter();
  // },[localStorage.getItem('contactShowFilterValues'),showColumns])

  const getContactsFilter = async () => {
    // axios.defaults.headers.common["x-access-token"] =
    //   authToken
    const res = await axiosHandler.post(url + "/leads/filterValues", {
      // uid: user.uid,
      showColumns:showColumns === null?contactFilterValues:JSON.parse(showColumns)
    });
      const userdetail = await axiosHandler.post(url + "/users/fetchSpecificData", {
        organization_id: user.organization_id,
        uid:user.uid
        });
    if (res.data[0]) {
      dispatcher(
        setFilterObject({
          ...res.data[0],
          'lead_type':['Data','Leads'],
          'employee_name':userdetail.data.data.Employee_Name,
          'employee_id':userdetail.data.data.Employee_id,
          ...booleanObject,
          status: ["Pending", "Cancelled", "Completed"],
          type:["Meeting","Site Visit","Call Back"]
        })
      );
    } else {
      dispatcher(setFilterObject({}));
    }
  };
  
  useEffect(() => {
    const storedValue = localStorage.getItem('contactShowFilterValues');
    setShowColumns(storedValue);
    if (user === undefined || user.uid === undefined) {
      return;
    }
    if(authToken){
      getContactsFilter();
    }
  }, [user,authToken,localStorage.getItem('contactShowFilterValues'),showColumns]);

  useEffect(() => {
    let contact: any[] = [];
    Object.keys(contacts.data).forEach((key) => {
      contact = [...contact, ...contacts.data[key]];
    });
    setAllContacts(contact);
  }, [contacts.data]);

  useEffect(() => {
    let mapReportingTo: { [key: string]: string } = {};
    if (organizationUsers) {
      organizationUsers.forEach((item: any) => {
        if (mapReportingTo[item.uid] === undefined) {
          mapReportingTo[item.uid] = item.reporting_to;
        }
      });
    }

    if (allContacts) {
      allContacts.forEach((item: any) => {
        if (item.uid === "") {
          item["reporting_to"] = "";
        } else {
          item["reporting_to"] = mapReportingTo[item.uid]
            ? mapReportingTo[item.uid]
            : "";
        }
      });
    }

    // eslint-disable-next-line
  }, [allContacts]);

  const setUsersList = () => {
    if (role === "Lead Manager") {
      organizationUsers.map((item: any) => {
        if (usersList.includes(item)) {
          return;
        } else {
          if (item.status === "ACTIVE" && item.profile != "Operation Manager") {
            usersList.push(item);
          }
        }
      });
    } 
    else if (user.profile === "Admin") {
      organizationUsers.map((item: any) => {
        if (usersList.includes(item)) {
          return;
        } else {
          if (item.status === "ACTIVE" && item.profile != "Operation Manager") {
            usersList.push(item);
          }
        }
      });
    } 
    else {
      createUsersList(user.user_email, organizationUsers, false);
    }
  };

  useEffect(() => {
    if (selectedRows.length > 0) {
      setOwner(true);
    } 
    else if (selectedRows.length === 0) {
      setOwner(false);
    }
  }, [selectedRows]);

  const clearSelectedRowsData = () => {
    setSelectedRowsData([]);
    setSelectedRows([]);
  };
  const [notesList, setNotesList] = useState<[]>([]);

  const exportFile = async () => {
    let data: any[] = [];
    let notesData: any;
    let notesMap: any;
    if (selectedRowsData.length === 0) {
    } else {
      let selectedRowIds = selectedRowsData.map(item => {
        return item.contactId
      })
      // axios.defaults.headers.common["x-access-token"] =
      // authToken
      let res = await axiosHandler.post(url + "/contactResourcesMongo/getNotesInBulk", {
        leadIds:selectedRowIds
      });
      notesData = res.data.data;
      // console.log("akakaa exported data",notesData);
      // console.log("selected rows data",selectedRowsData);
      // Create a Map for array2 for efficient lookups
     if(notesData){
      notesMap = new Map(notesData.map((item:any) => [item.leadId, item]));
     }
      // console.log("selected rows map",map2);
      {(!organizationData.business_domain || organizationData.business_domain== "Real Estate")?
      (
        selectedRowsData.forEach((item, index) => {
          const notesObj:any = notesMap.get(item.contactId);
          if (notesObj) {
            if (notesObj?.notes) {
              let allNotes: any = "";
              notesObj.notes.map((Mnote: any, noteIndex: any) => {
                // console.log("rData.notes",Mnote)
                //add multiple notes
                if (Mnote.note) {
                  let str: any = Mnote.note;
                  let str1: any = Mnote.userEmail;
                  let updatedNote = str.replace(/[\r\n]+/gm, " ");
                  let updatedEmail 
                  {str1 ? updatedEmail = str1.replace(/[\r\n]+/gm, " "):updatedEmail=''}
                  {str1 ? allNotes += updatedNote +" ( " + updatedEmail + " )  " + "||  ":allNotes += updatedNote + " , "} 
                } else {
                  allNotes += "";
                }
              });
              //adding Notes in selectedRowsData array
              item["Notes"] = allNotes;
            } else {
              item["Notes"] = "";
            }
          }else{
            item["Notes"] = "";
          }
          //Fetching Notes from firebase Code Start
          // firestore
          //   .collection("contactResources")
          //   .doc(item.contactId)
          //   .onSnapshot((resources) => {
          //     if (resources) {
          //       const rData = resources.data();
          //       if (rData?.notes) {
          //         let allNotes: any = "";
          //         rData.notes.map((Mnote: any, noteIndex: any) => {
          //           console.log("rData.notes",Mnote)
          //           //add multiple notes
          //           if (Mnote.note) {
          //             let str: any = Mnote.note;
          //             let str1: any = Mnote.userEmail;
          //             let updatedNote = str.replace(/[\r\n]+/gm, " ");
          //             let updatedEmail 
          //             {str1 ? updatedEmail = str1.replace(/[\r\n]+/gm, " "):updatedEmail=''}
          //             {str1 ? allNotes += updatedNote +" ( " + updatedEmail + " )  " + "||  ":allNotes += updatedNote + " , "} 
          //           } else {
          //             allNotes += "";
          //           }
          //         });
          //         //adding Notes in selectedRowsData array
          //         item["Notes"] = allNotes;
          //       } else {
          //         item["Notes"] = "";
          //       }
          //     }
          //   })
  
          //Fetching Notes from firebase code End
          data.push({
            // Id: item.contactId,
            "Notes": item.Notes,
            "Customer Name": item.customer_name,
            "Country Code": item.country_code,
            "Contact Number": item.contact_no,
            "Alternate Number": item.alternate_no,
            "Customer Email": item.email,
            'Lead Stage': item.stage,
            'Lead Assignee Email': item.contact_owner_email,
            "Reporting To":item?.reporting_to,
            "Branch":item?.branch,
            "Team":item?.team,
            "Lead Type":item?.lead_type,
            "Call Back Reason": item.call_back_reason,
            "Property Type": item.property_type,
            "Property Sub Type": item.property_sub_type,
            "Property Stage": item.property_stage,
            Location: item.location,
            Project: item.project,
            "Not Interested Reason": item.not_int_reason,
            "Lost Reason": item.lost_reason,
            "Other Not Interested Reason": item.other_not_int_reason,
            "Other Lost Reason": item.other_lost_reason,
            // "Previous Lead Assignee Email": item.previous_owner,
            "Next follow Up Type": item.next_follow_up_type,
            "Next Follow Up On": getDateStringUpdated(
              item.next_follow_up_date_time
            ),
            AddSet: item.addset,
            Campaign: item.campaign,
            "Inventory Type": item.inventory_type,
            Budget: item.budget,
            "Lead Source": item.lead_source,
            "Transfer Status": item.transfer_status,
            "Transfer Reason": item.transfer_reason,
            "Associate Status": item.associate_status,
            "Source Status": item.source_status,
            "Previous Lead Assignee Email 1": item.previous_owner_1,
            "Previous Lead Assignee Email 2": item.previous_owner_2,
            // "Previous Lead Stage 1": item.previous_stage_1,
            "Previous Lead Stage": item.previous_stage_2,
            // "Transfer By 1": item.transfer_by_1,
            "Transfer By": item.transfer_by_2,
            "Modified On": getDateStringUpdated(item.stage_change_at),
            "Lead Stage Changed On": getDateStringUpdated(item.stage_change_at),
            "Created By": item.created_by,
            "Created On": getDateStringUpdated(item.created_at),
            "Lead Assigned On": getDateStringUpdated(item.lead_assign_time),
            "Call Response Time": getDateStringUpdated(item.call_response_time),
            // is_button_called: item.is_button_called,
            "Employee ID":item.employee_id,
            "Lead Assignee": item.employee_name,
            'Lead State': item.state,
            'City': item.city,
            'Country': item.country,
            'Property Id': item.property_id,
            'Contact Message Details': item.contact_message_details
          });
        })
      ):
      (
        selectedRowsData.forEach((item, index) => {
          const notesObj:any = notesMap.get(item.contactId);
          if (notesObj) {
            if (notesObj?.notes) {
              let allNotes: any = "";
              notesObj.notes.map((Mnote: any, noteIndex: any) => {
                // console.log("rData.notes",Mnote)
                //add multiple notes
                if (Mnote.note) {
                  let str: any = Mnote.note;
                  let str1: any = Mnote.userEmail;
                  let updatedNote = str.replace(/[\r\n]+/gm, " ");
                  let updatedEmail 
                  {str1 ? updatedEmail = str1.replace(/[\r\n]+/gm, " "):updatedEmail=''}
                  {str1 ? allNotes += updatedNote +" ( " + updatedEmail + " )  " + "||  ":allNotes += updatedNote + " , "} 
                } else {
                  allNotes += "";
                }
              });
              //adding Notes in selectedRowsData array
              item["Notes"] = allNotes;
            } else {
              item["Notes"] = "";
            }
          }else{
             item["Notes"] = "";
          }
          //Fetching Notes from firebase Code Start
          // firestore
          //   .collection("contactResources")
          //   .doc(item.contactId)
          //   .onSnapshot((resources) => {
          //     if (resources) {
          //       const rData = resources.data();
          //       if (rData?.notes) {
          //         let allNotes: any = "";
          //         rData.notes.map((Mnote: any, noteIndex: any) => {
          //           console.log("rData.notes",Mnote)
          //           //add multiple notes
          //           if (Mnote.note) {
          //             let str: any = Mnote.note;
          //             let str1: any = Mnote.userEmail;
          //             let updatedNote = str.replace(/[\r\n]+/gm, " ");
          //             let updatedEmail 
          //             {str1 ? updatedEmail = str1.replace(/[\r\n]+/gm, " "):updatedEmail=''}
          //             {str1 ? allNotes += updatedNote +" ( " + updatedEmail + " )  " + "||  ":allNotes += updatedNote + " , "} 
          //           } else {
          //             allNotes += "";
          //           }
          //         });
          //         //adding Notes in selectedRowsData array
          //         item["Notes"] = allNotes;
          //       } else {
          //         item["Notes"] = "";
          //       }
          //     }
          //   })
  
          //Fetching Notes from firebase code End
          data.push({
            // Id: item.contactId,
            "Notes": item.Notes,
            "Customer Name": item.customer_name,
            "Country Code": item.country_code,
            "Contact Number": item.contact_no,
            "Alternate Number": item.alternate_no,
            "Customer Email": item.email,
            'Lead Stage': item.stage,
            'Lead Assignee Email': item.contact_owner_email,
            "Reporting To":item?.reporting_to,
            "Branch":item?.branch,
            "Team":item?.team,
            "Lead Type":item?.lead_type,
            "Call Back Reason": item.call_back_reason,
            // "Property Type": item.property_type,
            // "Property Sub Type": item.property_sub_type,
            // "Property Stage": item.property_stage,
            Location: item.location,
            Project: item.project,
            "Not Interested Reason": item.not_int_reason,
            "Lost Reason": item.lost_reason,
            "Other Not Interested Reason": item.other_not_int_reason,
            "Other Lost Reason": item.other_lost_reason,
            // "Previous Lead Assignee Email": item.previous_owner,
            "Next follow Up Type": item.next_follow_up_type,
            "Next Follow Up On": getDateStringUpdated(
              item.next_follow_up_date_time
            ),
            AddSet: item.addset,
            Campaign: item.campaign,
            // "Inventory Type": item.inventory_type,
            Budget: item.budget,
            "Lead Source": item.lead_source,
            "Transfer Status": item.transfer_status,
            "Transfer Reason": item.transfer_reason,
            "Associate Status": item.associate_status,
            "Source Status": item.source_status,
            "Previous Lead Assignee Email 1": item.previous_owner_1,
            "Previous Lead Assignee Email 2": item.previous_owner_2,
            // "Previous Lead Stage 1": item.previous_stage_1,
            "Previous Lead Stage": item.previous_stage_2,
            // "Transfer By 1": item.transfer_by_1,
            "Transfer By": item.transfer_by_2,
            "Modified On": getDateStringUpdated(item.stage_change_at),
            "Lead Stage Changed On": getDateStringUpdated(item.stage_change_at),
            "Created By": item.created_by,
            "Created At": getDateStringUpdated(item.created_at),
            "Lead Assign At": getDateStringUpdated(item.lead_assign_time),
            "Call Response Time": getDateStringUpdated(item.call_response_time),
            // is_button_called: item.is_button_called,
            "Business Vertical": item.business_vertical,
            "API Form":item.api_forms,
            "Employee ID":item.employee_id,
            "Employee Name":item.employee_name,
            "Lead State": item.state,
          });
        })
      )}
    }
    return data;
  };
  exportFile();

  // const fbLogin = () => {
  //   console.log("amak",Window.FB)
  // }
  
  const topBarStyles = {backgroundColor:theme ? themeColors.backgroundColor:themeColors.backgroundColorDark,width:"97%"}
  const parentStyles = {backgroundColor:theme ? themeColors.backgroundColor:themeColors.backgroundColorDark}

  useEffect(()=>{
    if(isGACalled === false){
      if(user?.uid && user?.profile){
        setIsGACalled(true)
        googleAnalytics('Contact_Screen',user)
      }
    }
  },[user])


  useEffect(() => {
    if (isUsingApp === false) {
      let newContactColumns: any = [];
      contactColumns.map((column: any) => {
        newContactColumns.push(column);
        if (column.Header === "Customer Name") {
          newContactColumns.push({
            Header: "Buyer Intent",
            accessor: "buyer_intent",
            Cell: (props: any) => {
              if (props.value === undefined) {
                return "";
              } else {
                return "";
              }
            },
            // filter: multiSelectFilter,
          })
        }
      })
      setContactColumns(
        newContactColumns
      )
    }
  }, [isUsingApp])

    useEffect(() => {
      let userData: any = localStorage.getItem("user");
      let parsedUser = JSON.parse(userData);
      if (parsedUser.autoToken) {
        setAutoToken(parsedUser.autoToken)
      }
    }, [])

    const [count, setCount] = useState<any>(0);

    useEffect(() => {
      const fetchLeadCount = async () => {
        try {
          const res:any = await maskedBossterMonthWise();
          if (res?.data?.count) {
            setCount(res.data.count);
          }
        } catch (error) {
          console.error("Error fetching masked booster count", error);
        }
      };
  
      fetchLeadCount();
    }, []);

    const [isHardRefresh, setIsHardRefresh] = useState(false);

useEffect(() => {
  const navEntries:any = performance.getEntriesByType('navigation');
  if (navEntries.length > 0 && navEntries[0].type === 'reload') {
    setIsHardRefresh(true);
  }
}, []);
  


return (
    <>
      <div className={styles.parent} style={{display:"block",marginTop:"0px",...parentStyles}}>
      {/* <div className="fb-login-button" data-width="100" data-size="" data-button-type="" data-layout="" data-auto-logout-link="false" data-use-continue-as="false"></div> */}
      {load === true && <Loading />}
      {cRoute&& isHardRefresh&&( <div className={styles.PbContainer}>
        <HtmlBanner   user={user} route={cRoute} bannerType={"pageBanner"}/>
      </div>)}
      {user.profile==="Admin" && user.user_oid && count!==0 && (<MaskedLeadBanner 
          leads={count}
          ctaText={"Recharge with Monthly Subscription"}
          onClick={() => {
            openCustomMMBURL(autoToken, "bricks/boosterDashboard.html?showPopup=true&intf=agent_mon_readPro_booster_banner&sr=contacts_tab_Recharge_now&pfm=WEB");
            pushToGA(
              "event_tracking",
              "read pro",
              "read pro",
              "booster banner click",
              user,
              "contacts tab | Recharge now"
            );
          }}
          
         user={user}

        />)}
        <div className={commonStyle.topBar} style={{marginTop:"0px",...topBarStyles}}>
          <ApiTopBar
            history={history}
            title={"Add Contacts"}
            path={"/addContacts"}
            onClick={() => {
              setShowImportModal(true); 
            }}
            owner={owner}
            deleteSelected={() => {
              setDeletePopop(true);
            }}
            changeOwner={() => {
              if(selectedRowsData.length>500){
                dispatcher(
                  showSnackbarAction(
                    'You can transfer a maximum of 500 records',
                    'error'
                  )
                );
              }else{
                setUsersList();
                setShow(true);
              }
            }}
            onChange={(val) => setsearchedItem(val)}
            filterText={"Status"}
            setColumnModal={(data) => setColumnModal(data)}
            show={true}
            showStatusBox={true}
            onExport={exportFile}
            setBulkEdit={() => {
              setShowBulkEdit(true);
            }}
            onCallLogsImport={() => {
              setCallLogsImportModal(true);
            }}
            onNotesImport={() => {
              setNotesImportModal(true);
            }}
            onTasksImport={() => {
              setTasksImportModal(true);
            }}
            searchedString={searchString}
            setAllLeads={(data) => setAllLeads(data)}
            transferLeads={transferStatusTrueRows}
            selectedRows={selectedRows}
            setAuditLog={setAuditLog} 
            isOtpVerified={isOtpVerified}
            panel = "contacts"
          />
        </div>
        <div className={commonStyle.parent} style={{minHeight:"450px"}}>
            {(!organizationData.business_domain || organizationData.business_domain== "Real Estate")?
            <ApiCustomTable
              tableColumns={contactColumns}
              tableRows={filterData}
              selectedRows={selectedRows}
              setSelectedRows={(data) => setSelectedRows(data)}
              tableType="User"
              showColumnModal={columnModal}
              hideColumnModal={() => setColumnModal(false)}
              selectedRowsData={selectedRowsData}
              setSelectedRowsData={(data) => setSelectedRowsData(data)}
              setPage={(val) => setPage(val)}
              setPageSize={(val) => setPageSize(val)}
              callApi={callApi}
              pageSize={pageSize}
              page={page}
              isFinished={isFinished}
              totalCount={totalCounts}
              lastPage={lastPage}
              
            />:
            <ApiCustomTable
              tableColumns={CONTACT_COLUMNS}
              tableRows={filterData}
              selectedRows={selectedRows}
              setSelectedRows={(data) => setSelectedRows(data)}
              tableType="User"
              showColumnModal={columnModal}
              hideColumnModal={() => setColumnModal(false)}
              selectedRowsData={selectedRowsData}
              setSelectedRowsData={(data) => setSelectedRowsData(data)}
              setPage={(val) => setPage(val)}
              setPageSize={(val) => setPageSize(val)}
              callApi={callApi}
              pageSize={pageSize}
              page={page}
              isFinished={isFinished}
              totalCount={totalCounts}
              lastPage={lastPage}
            />}
            {show && (
              <OwnerModal
                open={show}
                close={() => {
                  setShow(false);
                }}
                usersList={usersList}
                rowsSelected={selectedRowsData}
                clearSelectedRowsData={clearSelectedRowsData}
                organization_id={user.organization_id}
                freshFilterValue={freshFilterValue}

              />
            )}
            {deletePopup && (
              <DeleteSelectedModalSoftDelete
                data={selectedRowsData}
                clearSelectedRowsData={clearSelectedRowsData}
                open={deletePopup}
                history={history}
                close={() => {
                  setDeletePopop(false);
                }}
                panel = "contacts"
                selectedRows={selectedRows}
              />
            )}
            {showImportModal && (
              <NewImportContactModal
                open={showImportModal}
                close={() => setShowImportModal(false)}
                organization_id={user.organization_id}
                history={history}
                usersList={organizationUsers}
                user={user}
              />
            )}
            {callLogsImportModal && (
              <ImportCallLogsModal
                open={callLogsImportModal}
                close={() => setCallLogsImportModal(false)}
                organization_id={user.organization_id}
                usersList={organizationUsers}
              />
            )}

            {notesImportModal && (
              <ImportNotesModal
                open={notesImportModal}
                close={() => setNotesImportModal(false)}
              />
            )}
            {tasksImportModal && (
              <ImportTasksModal
                open={tasksImportModal}
                close={() => setTasksImportModal(false)}
                organization_id={user.organization_id}
                usersList={organizationUsers}
                user={user}
              />
            )}
            {showBulkEdit && (
              <BulkEditModal
                open={showBulkEdit}
                organization_id={user.organization_id}
                close={() => {
                  setShowBulkEdit(false);
                  clearSelectedRowsData();
                }}
                rowsData={selectedRowsData}
              />
            )}
            {auditLog && (
              <PopUpBox
              open={auditLog}
              close={() => setAuditLog(false)}
              setIsOtpVerified={setIsOtpVerified}
              setAuditLog={setAuditLog}
              onExport={exportFile}
              selectedRows={selectedRows}
              panel = "contacts"
              />)}
          </div>
      </div>
        {/* {
            showFreeTrialModal &&
            <CenteredPopUp
                setModal={setShowFreeTrialModal}
                children={<FreeTrialWhatsappModal />}
                modiferClass={styles.ftmModal}
                closeIcon={true}
                closeClassMofifier={styles.ftmClose}
            />
        } */}
        {/* {
            showTrialActivatedModal &&
            <CenteredPopUp
                setModal={setShowTrialActivatedModal}
                children={<FreeTrialActivatedModal />}
                modiferClass={styles.ftaModal}
                closeIcon={true}
                closeClassMofifier={styles.ftaClose}
            />
        } */}
    </>
  );

};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    role: state.user.role,
    contacts: state.contacts,
    organizationUsers: state.organizationUsers.data,
    teamLeadUsers: state.teamLeadUsers.data,
    // filterObject: state.filter,
    // filterSort: state.filterSort,
    filterObject: state.userFilter,
    filterSort: state.userfilterSort,
    refreshContacts: state.refresh.refreshContacts,
    searchString: state.searchItem.contactsSearchString,
    theme: state.theme.isLightMode,
    authToken:state.user.authToken,
    organizationData: state.organization.organizationData,
    isUsingApp: state.user.isUsingApp
  };
};

export default connect(mapStateToProps)(UserPanel);
